import { HomeWrapper } from '../../src/components/HomePage/HomeBanner/styled';
import NewHeader from '../../src/components/HomePage/NewHeader';
import Overview from '../../src/components/PrivacyPolicy/Overview';
import GlobalStyle from '../../src/styles/globalStylesV2';
import LazyLoad from 'react-lazyload';
// const NewFooter = dynamic(() =>
//     import("../../src/components/HomePage/NewFooter"),
// );
import NewFooter from '../../src/components/HomePage/NewFooter';
import { NextSeo } from 'next-seo';
import { privacyPolicyMetaData } from '../../src/Constants/MetaData';

export default function index() {
  return (
    <>
      <GlobalStyle />
      <NextSeo
        noindex={true}
        nofollow={true}
        title={privacyPolicyMetaData.metaTitle}
        description={privacyPolicyMetaData.metaDescription}
      />
      <NewHeader nostrip={true} />
      <HomeWrapper>
        <Overview />
      </HomeWrapper>
      <LazyLoad height={100} once offset={100}>
        <NewFooter />
      </LazyLoad>
    </>
  );
}
